import { render, staticRenderFns } from "./Strength.vue?vue&type=template&id=71f22f16&scoped=true&"
import script from "./Strength.vue?vue&type=script&lang=js&"
export * from "./Strength.vue?vue&type=script&lang=js&"
import style0 from "./Strength.vue?vue&type=style&index=0&id=71f22f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f22f16",
  null
  
)

export default component.exports